import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateField as MuiDateField } from '@mui/x-date-pickers/DateField';
import type { FC } from 'react';
import type { IDateField } from './DateField.types';

const DateField: FC<IDateField> = ({ value, sx, ...rest }) => {
  // Convert string to Date, but preserve Date objects (including Invalid Date)
  // This allows MUI DateField to handle intermediate invalid states during editing
  let dateValue: Date | null = null;

  if (value) {
    if (value instanceof Date) {
      // Pass Date as-is, even if Invalid Date (needed for editing)
      dateValue = value;
    } else {
      // Convert string to Date and validate
      const date = new Date(value);
      dateValue = !isNaN(date.getTime()) ? date : null;
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDateField
        {...rest}
        value={dateValue}
        sx={{
          width: '100%',
          ...sx,
        }}
      />
    </LocalizationProvider>
  );
};

export default DateField;
